import React from 'react';
import { IconButton } from '@mui/material';
import { EditOutlined, CloseCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { IntegrationType, TransactionStatus } from '../graphql/types';
import { useTheme } from '@mui/material/styles';
import CustomTooltip from './CustomTooltip';

interface TransactionsActionsCellRendererProps {
  data: any;
  node: any;
  setTransaction: (data: any) => void;
  handleEditNote: () => void;
  handleManualEdit: () => void;
  setOpenCancelConfirmation: (open: boolean) => void;
  setOpenDeleteConfirmation: (open: boolean) => void;
  isSuperAdmin: boolean;
  manualTransactions: string[];
}

const TransactionsActionsCellRenderer: React.FC<TransactionsActionsCellRendererProps> = ({
  data,
  node,
  setTransaction,
  handleEditNote,
  handleManualEdit,
  setOpenCancelConfirmation,
  setOpenDeleteConfirmation,
  isSuperAdmin,
  manualTransactions
}) => {
  const theme = useTheme();
  if (node.isRowPinned()) {
    return null;
  }
  const isLiftoffAch = data.integration?.type ===  IntegrationType.LiftoffCard && data.paymentMethod.id ==='ACH';

  switch (true) {
    case data.status === TransactionStatus.Processed:
      return (
        <>
          <span className="hover-action-content">
            <CustomTooltip title="Edit Note">
              <IconButton
                sx={{
                  color: theme.palette.lightgreen.main
                }}
                onClick={(e: any) => {
                  e.stopPropagation();
                  setTransaction(data);
                  handleEditNote();
                }}
              >
                <EditOutlined />
              </IconButton>
            </CustomTooltip>
          </span>
          <span className="hover-action-content">
            <CustomTooltip title="Cancel">
              <IconButton
                sx={{
                  color: theme.palette.warning.main
                }}
                onClick={(e: any) => {
                  e.stopPropagation();
                  setTransaction(data);
                  setOpenCancelConfirmation(true);
                }}
              >
                <CloseCircleOutlined />
              </IconButton>
            </CustomTooltip>
          </span>
        </>
      );
    case !manualTransactions.includes(data.type):
      return (
        <>
          <span className="hover-action-content">
            <CustomTooltip title="Edit Note">
              <IconButton
                sx={{
                  color: theme.palette.lightgreen.main
                }}
                onClick={(e: any) => {
                  e.stopPropagation();
                  setTransaction(data);
                  handleEditNote();
                }}
              >
                <EditOutlined />
              </IconButton>
            </CustomTooltip>
          </span>
        </>
      );
    case manualTransactions.includes(data.type):
      return (
        <>
          {isSuperAdmin && (
            <>
              <span className="hover-action-content">
                <CustomTooltip title="Edit">
                  <IconButton
                    sx={{
                      color: theme.palette.lightgreen.main
                    }}
                    onClick={(e: any) => {
                      e.stopPropagation();
                      setTransaction(data);
                      handleManualEdit();
                    }}
                  >
                    <EditOutlined />
                  </IconButton>
                </CustomTooltip>
              </span>
            </>
          )}
          {data.status !== TransactionStatus.Cancelled && (
            <>
              <span className="hover-action-content">
                <CustomTooltip title="Cancel">
                  <IconButton
                    sx={{
                      color: theme.palette.warning.main
                    }}
                    onClick={(e: any) => {
                      e.stopPropagation();
                      setTransaction(data);
                      setOpenCancelConfirmation(true);
                    }}
                  >
                    <CloseCircleOutlined />
                  </IconButton>
                </CustomTooltip>
              </span>
            </>
          )}
          {isSuperAdmin && !isLiftoffAch &&  (
            <span className="hover-action-content">
              <CustomTooltip title="Delete">
                <IconButton
                  sx={{
                    color: theme.palette.error.main
                  }}
                  onClick={(e: any) => {
                    e.stopPropagation();
                    setTransaction(data);
                    setOpenDeleteConfirmation(true);
                  }}
                >
                  <DeleteOutlined />
                </IconButton>
              </CustomTooltip>
            </span>
          )}
        </>
      );
    default:
      return null;
  }
};

export default TransactionsActionsCellRenderer;
